/**
 * SelectionCode component - Displays selection codes
 */

import React from 'react';
import { Chip, Box, Typography } from '@mui/material';
import colors from '../../../themes/colors';
import { promotionTypography } from '../../../themes/typography';

/**
 * Selection code display
 */
const SelectionCode = ({ code, sx = {} }) => {
  const isDisabled = !code || code === 'N/A';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        my: 3,
        ...sx
      }}
    >
      {/* Instructions */}
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          textAlign: 'center',
          fontSize: { xs: '0.875rem', md: '1rem' }
        }}
      >
        📟 Introduce este código en la máquina
      </Typography>

      {/* Code Display */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Chip
          label={
            <Typography 
              component="span" 
              sx={{ 
                ...promotionTypography.codeDisplay,
                color: isDisabled ? 'text.disabled' : 'inherit'
              }}
            >
              Código: {code}
            </Typography>
          }
          disabled={isDisabled}
          sx={{
            bgcolor: colors.promotion.cardBg,
            color: colors.text.primary,
            border: `2px solid ${colors.ui.border}`,
            px: 2,
            py: 1.5,
            height: 'auto',
            fontSize: { xs: '1rem', md: '1.125rem' },
            fontWeight: 600,
            boxShadow: `0 2px 8px ${colors.promotion.shadow}`,
            maxWidth: '100%',
            '& .MuiChip-label': {
              px: 1,
              fontSize: 'inherit',
              fontWeight: 'inherit',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            },
            '&.Mui-disabled': {
              bgcolor: colors.background.default,
              color: colors.text.disabled,
              opacity: 0.6
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default SelectionCode;